const url = '/ws';
const formUrl = 'http://localhost/exter/formulario/index.html';
export { url, formUrl };
